import config from "config.json";
import {
	getEnvironment,
	isCdnPage,
	isDevelopmentEnvironment,
	objectIsEmpty,
} from "./index";
import { getCookie, setCookie } from "./cookie";

export const localeRegExp = /^\/([a-z]{2}((_|-)[A-Za-z]{2})?)(\/|$)/;

export const getDefaultLocale = (brand) => {
	return (config?.brands?.[brand]?.defaultLocale || config.defaultLocale)
		.toLowerCase()
		.replace("_", "-");
};

export const getDefaultLocaleCookie = (brand) => {
	return (
		config?.brands?.[brand]?.defaultLocaleCookie || config.defaultLocaleCookie
	);
};

export const getDefaultLocaleCookieProperty = (brand) => {
	return (
		config?.brands?.[brand]?.defaultLocaleCookieProperty ||
		config.defaultLocaleCookieProperty
	);
};

export const processLocale = (value = "") => {
	return value
		?.replace(/\//g, "")
		.toLowerCase()
		.replace("-", "")
		.replace("_", "");
};

export const getLangFromLangSelectorUrl = (url = "") => {
	let lang = null;
	if (url.match(/^http/)) {
		if (url.match(/\/(jp|ja|ja-jp)\//gi)) {
			lang = "ja";
		}
	}

	if (url.match(localeRegExp)) {
		lang = url.replaceAll("/", "").replaceAll("_", "-");
	}

	return lang;
};

export const processLanguageSelectorUrl = (url = "", brand = "") => {
	if (url.match(/^http/)) return url;
	const currentLocale =
		window?.location.pathname.match(localeRegExp)?.[0] || "";
	const targetUrl = window?.location.href.replace(window?.location.origin, "");

	// workaround for dp en link
	if (brand === "dp") {
		if (url.split("/").includes(getDefaultLocale("dp"))) {
			url = "/";
		}
	}

	if (currentLocale) {
		return targetUrl.replace(currentLocale, url);
	} else {
		return url.concat(targetUrl.replace("/", ""));
	}
};

export const setLanguageCookies = (cookies) => {
	const cookieExpirationInDays = 2;
	for (const cookieJarName in cookies) {
		const cookie = getCookie(cookieJarName);
		let cookieValue = cookies[cookieJarName];
		try {
			if (cookie) {
				cookieValue = JSON.parse(decodeURIComponent(cookie));
			}
			if (!objectIsEmpty(cookieValue)) {
				setCookie(
					cookieJarName,
					encodeURIComponent(
						JSON.stringify({
							...cookieValue,
							...cookies[cookieJarName],
						})
					),
					cookieExpirationInDays
				);
			}
		} catch (error) {
			console.error(error);
		}
	}
};

export const getLanguageCookies = (
	cookiesToSet,
	locale,
	localeCurrency,
	preferredLanguage
) => {
	const cookiesToSetNew = {};
	if (!objectIsEmpty(cookiesToSet)) {
		for (const cookieJar in cookiesToSet) {
			cookiesToSetNew[cookieJar] = {};
			for (const cookie in cookiesToSet[cookieJar]) {
				switch (cookie) {
					case "preferredRegion":
						cookiesToSetNew[cookieJar][cookie] = locale;
						break;
					case "localeCurrency":
						cookiesToSetNew[cookieJar][cookie] = localeCurrency;
						break;
					case "preferredLanguage":
						cookiesToSetNew[cookieJar][cookie] = preferredLanguage;
						break;
					case "language":
						cookiesToSetNew[cookieJar][cookie] = preferredLanguage;
						break;
					default:
						cookiesToSetNew[cookieJar][cookie] =
							cookiesToSet[cookieJar][cookie];
				}
			}
		}
	}
	return cookiesToSetNew;
};

export const validateGdprDomainByBrand = (brand, currentLocale) => {
	const gdprHostnames = config?.brands?.[brand]?.gdprHostnames;
	if (gdprHostnames) {
		const gdprHostnamesKeys = Object.keys(gdprHostnames);
		if (isCdnPage() || isDevelopmentEnvironment(getEnvironment())) {
			const newLocale = processLocale(currentLocale);
			for (let index = 0; index < gdprHostnamesKeys.length; index++) {
				if (
					processLocale(gdprHostnames[gdprHostnamesKeys[index]]) === newLocale
				) {
					return gdprHostnamesKeys[index];
				}
			}
			return false;
		} else {
			const host = window?.location.host;
			return gdprHostnamesKeys.find((hostName) => host.includes(hostName));
		}
	} else {
		return false;
	}
};

export const getGDPRLocale = (brand) => {
	const gdprHostnames = config?.brands?.[brand]?.gdprHostnames;
	if (!gdprHostnames) return null;
	let locale;

	for (const hostname in gdprHostnames) {
		if (
			window?.location.hostname.includes(hostname) &&
			gdprHostnames[hostname]
		) {
			locale = gdprHostnames[hostname];
			break;
		}
	}
	return locale;
};

export const localizeLinkUrl = (linkUrl) => {
	const origin = window.location.origin;
	if (!origin.endsWith(".eu") && !origin.endsWith(".co.uk")) {
		return linkUrl;
	}
	const url = new URL(linkUrl, origin);
	url.href = origin + url.pathname;
	return url.href;
};
